import React, { useState, useEffect } from 'react';
import './Cookie-Banner.css';

interface CookieBannerProps {
  className?: string;
}

const CookieBanner: React.FC<CookieBannerProps> = ({ className }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [countdown, setCountdown] = useState(30);

  useEffect(() => {
    // Check if banner has already been shown in this session
    const bannerShown = sessionStorage.getItem('cookieBannerShown');
    
    // Only show if not explicitly marked as shown
    if (bannerShown !== 'true') {
      setIsVisible(true);
      setCountdown(30);

      // Start countdown timer
      const countdownInterval = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(countdownInterval);
            hideBanner();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      // Auto-hide after 30 seconds (backup)
      const timeout = setTimeout(() => {
        clearInterval(countdownInterval);
        hideBanner();
      }, 30000); // 30 seconds

      // Cleanup timeout and interval on component unmount
      return () => {
        clearTimeout(timeout);
        clearInterval(countdownInterval);
      };
    }
  }, []);

  const hideBanner = () => {
    setIsVisible(false);
    sessionStorage.setItem('cookieBannerShown', 'true');
  };

  const handleAccept = () => {
    hideBanner();
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div id="cookieBanner" className={`cookie-banner ${className || ''}`}>
      <div className="cookie-banner-content">
        <span>
          We use only essential cookies necessary for the proper functioning of this website.
          For more information, please visit our{' '}
          <a href="https://www.ypog.law/en/privacy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>{' '}
          and{' '}
          <a href="https://www.ypog.law/en/legal-notice" target="_blank" rel="noopener noreferrer">
            Imprint
          </a>
          .
          {countdown > 0 && (
            <span style={{ marginLeft: '10px', fontSize: '0.9em', color: '#666' }}>
              (Auto-close in {countdown}s)
            </span>
          )}
        </span>
        <button id="cookieAccept" className="cookie-accept-btn" onClick={handleAccept}>
          OK
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;